module.exports = __webpack_public_path__ + "media/images/icons/chevron-circle-left-e8a005db2df55a07692fca5e711d004b.svg";